import { render, staticRenderFns } from "./StepText.vue?vue&type=template&id=09ff9930&scoped=true"
import script from "./StepText.vue?vue&type=script&lang=js"
export * from "./StepText.vue?vue&type=script&lang=js"
import style0 from "./StepText.vue?vue&type=style&index=0&id=09ff9930&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff9930",
  null
  
)

export default component.exports